import { FC, Fragment } from 'react';

import cx from 'classnames';
import { Row } from 'react-table';

interface TableRowComponent {
  props: any;
  rows: Row<object>[];
  prepareRow: (row: Row<object>) => void;
  bodyClassName?: string;
  showRowPointer?: boolean;
  onTableRowClick?: (data: any, isExpanded: boolean) => void;
  tableDataClassName?: string;
  isCustom?: boolean;
  getRowHref?: (data: any) => string | undefined;
}

const TableRowComponent: FC<TableRowComponent> = ({
  props,
  rows,
  prepareRow,
  bodyClassName,
  showRowPointer,
  onTableRowClick,
  tableDataClassName,
  isCustom,
  getRowHref
}) => {
  const index = props['data-index'];
  const row = rows[index];
  prepareRow(row);

  const href = getRowHref?.(row.original);

  return (
    <tr
      {...props}
      {...row.getRowProps()}
      key={`data-${index}`}
      data-testid='patient-list-rows'
      className={`${
        !bodyClassName
          ? cx('h-12 hover:bg-HOVER_BLUE', {
              'bg-GRAY': index % 2 !== 0,
              'bg-LIGHT_BLUE_5': row.isExpanded,
              'cursor-pointer': showRowPointer
            })
          : bodyClassName
      }`}
      onClick={(e) => {
        if (href && (e.ctrlKey || e.metaKey)) {
          window.open(href, '_blank', 'noopener,noreferrer');
          return;
        }
        onTableRowClick?.(row.original, !row.isExpanded);
      }}
    >
      {row.cells.map((cell: any, cellIndex: number) => {
        return (
          <Fragment key={`data-cell-${cellIndex}`}>
            <td
              {...cell.getCellProps()}
              className={
                tableDataClassName
                  ? tableDataClassName
                  : `${!isCustom && 'box-borders px-2'} text-sm`
              }
            >
              {cellIndex === 0 && href ? (
                <a
                  href={href}
                  onClick={(e) => e.preventDefault()}
                  className='contents'
                >
                  {cell.render('Cell')}
                </a>
              ) : (
                cell.render('Cell')
              )}
            </td>
          </Fragment>
        );
      })}
    </tr>
  );
};

export default TableRowComponent;
